import { useState } from "react";
import { Plane, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import EngineFligths from "../engine/EngineFligths";
import EngineAssistance from "../engine/EngineAssistance";
import Background from "../engine/Background";
const EngineSection = () => {
  const tabs = [
    { id: "vuelos", label: "Vuelos", icon: Plane },
    { id: "seguros", label: "Seguros", icon: ShieldCheck },
  ];
  const [activeTab, setActiveTab] = useState("vuelos");

  return (
    <section className="relative hero-gradient min-h-[500px] lg:min-h-[600px] overflow-hidden">
      <Background />
      <div className="container mx-auto px-4 py-3 lg:py-12 relative z-10">
        {/* Tabs */}
        <div className="flex justify-center mb-3 md:mb-8">
          <div className="flex flex-wrap justify-center gap-1 bg-primary/30 backdrop-blur-sm p-1 rounded-full">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={cn(
                  "relative flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-full transition-all duration-300",
                  activeTab === tab.id
                    ? "bg-background text-foreground shadow-lg"
                    : "text-primary-foreground hover:bg-white/10"
                )}
              >
                <tab.icon className="w-4 h-4" />
                <span className=" sm:inline">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>
        {/* Search Card */}
        <div className="max-w-4xl mx-auto bg-navy-lightest border border-navy-lighter rounded-2xl shadow-2xl px-5 py-4 lg:py-8 lg:px-8 animate-slide-up">
          {activeTab === "vuelos" ? (
            <EngineFligths></EngineFligths>
          ) : (
            <EngineAssistance></EngineAssistance>
          )}
        </div>
      </div>
    </section>
  );
};

export default EngineSection;
